import React from 'react';
import { Slider } from '@mui/material';

// Generate mark styles dynamically based on marks array
const generateMarkStyles = (marks, currentCredits) => {
  // MUI internal structure: rail, track, thumb, then marks start at child 4
  // Each mark has 2 elements (mark + label), so mark indices are 4, 6, 8, 10...
  const BASE_CHILD_INDEX = 4;
  const CHILD_STEP = 2;

  return marks.reduce((styles, mark, index) => {
    const currStyles = { ...styles };
    // Skip first and last mark
    if (index === 0 || index === marks.length - 1) return currStyles;

    const childIndex = BASE_CHILD_INDEX + index * CHILD_STEP - 1;
    const isActive = Number(mark.value) <= Number(currentCredits);

    currStyles[`& .MuiSlider-mark:nth-child(${childIndex})`] = {
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: isActive ? '#FFFFFF' : '#3C3C4329',
      zIndex: 50,
      opacity: 1,
    };

    return currStyles;
  }, {});
};

const NewCreditsSlider = ({
  currentCredits,
  handleChangeCredits,
  maxNumberOptionCredit,
  minNumberOptionCredit,
  marks,
}) => {
  const markStyles = generateMarkStyles(marks, currentCredits);

  return (
    <Slider
      value={currentCredits}
      onChange={handleChangeCredits}
      step={null}
      marks={marks}
      min={0}
      max={maxNumberOptionCredit + minNumberOptionCredit}
      valueLabelDisplay="off"
      sx={{
        '& .MuiSlider-track': {
          backgroundColor: '#1E164E',
          color: '#1E164E',
          height: '8px',
          border: 'none',
          zIndex: 50,
          opacity: currentCredits === maxNumberOptionCredit && 0,
        },
        '& .MuiSlider-rail': {
          backgroundColor:
            currentCredits === maxNumberOptionCredit ? '#1E164E' : '#3C3C4314',
          height: '8px',
          opacity: currentCredits === maxNumberOptionCredit ? 1 : 0.5,
        },
        '& .MuiSlider-thumb': {
          width: 16,
          height: 16,
          backgroundColor: '#FFFFFF',
          borderRadius: '50%',
          border: '3px solid #1E164E',
          zIndex: 51,
          '&:before': {
            display: 'none',
          },
          '&:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'none',
          },
        },
        ...markStyles,
        '& .MuiSlider-markLabel': {
          fontWeight: 400,
          fontSize: 12,
          letterSpacing: -0.4,
          textAlign: 'center',
          color: '#1C1C1E7A',
        },
        '& .MuiSlider-markLabelActive': {
          color: '#1C1C1E',
        },
      }}
    />
  );
};

export default NewCreditsSlider;
